import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider as StyledThemeProvider, StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

import './index.css';
import './i18n'; // Import i18n config (to be created)
import App from './App';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { typography } from './design-system/tokens/typography';
import { spacing } from './design-system/tokens/spacing';
import { shadows } from './design-system/tokens/shadows';
import { borders } from './design-system/tokens/borders';
import { animations } from './design-system/tokens/animations';
import { breakpoints } from './design-system/tokens/breakpoints';

const shouldForwardProp = (propName: string, target: unknown) => {
  if (typeof target === 'string') {
    return isPropValid(propName);
  }
  return true;
};

const AppWithTheme: React.FC = () => {
  const theme = useTheme();
  
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <StyledThemeProvider 
        theme={{ 
          colors: theme.colors, 
          typography,
          spacing,
          shadows,
          borders,
          animations,
          breakpoints,
        }}
      >
        <App />
      </StyledThemeProvider>
    </StyleSheetManager>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  </React.StrictMode>
);
